<template>
  <tv-page title="TV标销-商品首页" :class="_.page">
    <template v-if="!loading">
      <div :class="_.goods">
        <div :class="_.hd">
          <img v-focusable :src="storeDetail.storeLogo" :class="_.cover" />
          <div :class="_.content">
            <p :class="_.title">{{ storeDetail.storeName }}</p>
            <div :class="_.collect">
              <img
                v-for="c in storeDetail.evaluateStat"
                :key="c"
                src="./images/收藏.png"
              />
              <img
                v-for="c in 5 - storeDetail.evaluateStat"
                :key="c"
                src="./images/未收藏.png"
              />
              <span>{{ storeDetail.evaluateStat }}.0</span>
            </div>
            <div :class="_.message">
              <span>营业时间：{{ storeDetail.openPeriod }}</span>
              <span :class="_.phone">
                <img src="./images/电话.png" />
                {{ storeDetail.storePhone }}
              </span>
              <span :class="_.phone">
                <img src="./images/地址.png" />
                {{ storeDetail.address }}
              </span>
            </div>
          </div>
        </div>
        <div :class="_.coupon">
          <template v-if="vouchersList.length">
            <p :class="_.title">代金券</p>
            <div ref="coupon" :class="_.list">
              <div
                v-for="item in vouchersList"
                :key="item.commodityId"
                v-focusable
                :class="_.content"
                v-on="couponListeners"
              >
                <div>
                  <p :class="_.sum">{{ item.commodityTitle }}</p>
                  <p :class="_.date">{{ storeDetail.openPeriod }}</p>
                  <p :class="_.price">
                    <span>¥</span>
                    <span :class="_.now">{{ item.lowestPrice }}</span>
                    <span v-if="item.dashPrice" :class="_.original"
                      >¥{{ item.dashPrice }}</span
                    >
                  </p>
                </div>
                <span :class="_.btn">立即购买</span>
              </div>
            </div>
          </template>
          <p :class="_.title">套餐</p>
          <ul ref="list">
            <li
              v-for="item in comboCouponsList"
              :key="item.commodityId"
              v-focusable
              v-on="listListeners"
            >
              <x-square>
                <van-image
                  :src="item.coverPic"
                  :class="_.cover"
                  fit="cover"
                  lazy-load
                />
              </x-square>
              <div :class="_.list_li">
                <p :class="_.goods_title">{{ item.commodityTitle }}</p>
                <div :class="_.goods_content">
                  <p :class="_.price">
                    <span>¥</span>
                    <span :class="_.now">{{ item.lowestPrice }}</span>
                    <span v-if="item.dashPrice" :class="_.original"
                      >¥{{ item.dashPrice }}</span
                    >
                  </p>
                  <span :class="_.number">已售{{ item.sales }}</span>
                </div>
              </div>
            </li>
          </ul>
          <tv-empty v-if="!comboCouponsList.length" message="暂无套餐" />
        </div>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { apiCommodityWriteOffCommodityStoreDetail } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { defineTvListeners } from '../utils'
  import { mapQuery, Track } from '@/utils'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-商品首页',
      })),
      mapQuery({
        // 店铺 ID
        martId: 'martId',
      }),
    ],

    data() {
      return {
        // 页面加载状态
        loading: true,
        collectValue: 4,
        vouchersList: [], //代金券列表
        comboCouponsList: [], //套餐券
        storeDetail: '', //店铺信息
        //跳到代金券列表
        goToCoupon: index => {
          this.$tv.goTo(this.$refs.coupon, index)
        },

        //跳到套餐列表
        goToList: index => {
          this.$tv.goTo(this.$refs.list, index)
        },

        //代金券列表监听事件
        couponListeners: defineTvListeners(
          ({ type, index, isFirst, isLast }) => {
            switch (type) {
              case 'left':
                if (!isFirst) {
                  this.goToCoupon(index - 1)
                } else {
                  this.goToCoupon(index)
                }
                break
              case 'right':
                if (!isLast) {
                  this.goToCoupon(index + 1)
                } else {
                  this.goToList(0)
                }
                break
              case 'click':
                this.handleClickGoods(this.vouchersList[index])
                break
              default:
                break
            }
          },
        ),

        //套餐列表监听事件
        listListeners: defineTvListeners(({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'left':
              if (isFirst) {
                this.goToCoupon(0)
              } else {
                this.goToList(index - 1)
              }
              break
            case 'right':
              if (!isLast) {
                this.goToList(index + 1)
              } else {
                this.goToList(index)
              }
              break
            case 'click':
              this.handleClickGoods(this.comboCouponsList[index])
              break
            default:
              break
          }
        }),
      }
    },

    async mounted() {
      const userInfo = await dcb.getUserInfo()
      console.log('用户信息', userInfo)
      await this.getStoreDetail()
      this.loading = false
      this.$nextTick(() => {
        if (this.vouchersList.length) {
          this.goToCoupon(0)
        } else {
          this.goToList(0)
        }
      })
    },

    methods: {
      //点击套餐
      handleClickGoods(item) {
        navigateTo('TvBookGoodsIndex', { id: item.commodityId })
      },
      getStoreDetail() {
        return apiCommodityWriteOffCommodityStoreDetail({
          storeId: this.martId,
        }).then(res => {
          this.storeDetail = res.store
          this.comboCouponsList = res.comboCoupons
          this.vouchersList = res.vouchers
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background: url('./images/背景.png') no-repeat;
    background-size: cover;
  }

  .goods {
    padding: 60px 80px;
    overflow-y: scroll;

    .hd {
      display: flex;
      margin-bottom: 56px;

      .cover {
        width: 160px;
        height: 160px;
        border-radius: 20px;
        overflow: hidden;
        border: 2px solid #ffffff;
        margin-right: 40px;
      }

      .content {
        .title {
          font-size: 40px;
          color: #ffffff;
          line-height: 58px;
          margin-bottom: 10px;
        }

        .collect {
          display: flex;
          font-size: 30px;
          color: #ff960a;
          line-height: 30px;
          margin-bottom: 22px;

          img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }

          span {
            margin-left: 10px;
          }
        }

        .message {
          font-size: 28px;
          font-weight: 400;
          color: #a7a6a3;
          line-height: 40px;

          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }

          span {
            margin-right: 60px;
          }
        }
      }
    }

    .coupon {
      .title {
        width: 295px;
        font-size: 36px;
        color: #a7a6a3;
        line-height: 52px;
        margin-bottom: 30px;
      }

      .list {
        display: grid;
        grid-template-columns: 560px 560px 560px;
        grid-gap: 40px 40px;
        margin-bottom: 50px;
      }

      .content {
        display: flex;
        height: 160px;
        border-radius: 16px;
        --border-radius: 20px;
        background: url('./images/代金券.png') no-repeat;
        background-size: contain;
        padding: 20px;
        color: #ffffff;
        position: relative;

        .sum {
          width: 370px;
          font-size: 32px;
          line-height: 46px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .date {
          font-size: 24px;
          line-height: 34px;
          color: #ffedd4;
          margin-bottom: 15px;
          margin-top: 10px;
        }

        .price {
          font-size: 26px;
          line-height: 37px;
        }

        .now {
          font-size: 44px;
          line-height: 50px;
          margin-left: 5px;
        }

        .original {
          font-size: 26px;
          line-height: 37px;
          color: #ffedd4;
          text-decoration: line-through;
          margin-left: 10px;
        }

        .btn {
          width: 80px;
          height: 92px;
          font-size: 32px;
          font-weight: bold;
          color: #ff960a;
          line-height: 46px;
          position: absolute;
          top: 55px;
          right: 40px;
          text-align: right;
        }
      }

      ul {
        display: grid;
        grid-template-columns: 320px 320px 320px 320px 320px;
        grid-gap: 40px;

        li {
          border-radius: 16px;
          --border-radius: 20px;

          .cover {
            border-radius: 16px 16px 0 0;
            overflow: hidden;
          }

          .list_li {
            background: #ffffff;
            padding: 20px;
            border-radius: 0 0 16px 16px;

            .goods_title {
              font-size: 30px;
              font-weight: bold;
              color: #333333;
              height: 88px;
              line-height: 44px;
              margin-bottom: 17px;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .goods_content {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .price {
                font-size: 26px;
                color: #ff3b30;
                font-weight: 400;
                line-height: 34px;
              }

              .now {
                font-size: 44px;
                font-weight: bold;
                color: #ff3b30;
                line-height: 50px;
                margin-left: 5px;
              }

              .original {
                font-size: 26px;
                color: #999999;
                line-height: 37px;
                text-decoration: line-through;
                margin-left: 6px;
              }

              .number {
                font-size: 26px;
                color: #999999;
                line-height: 37px;
              }
            }
          }
        }
      }
    }
  }
</style>
